export const shapeColours = [
  '#EEE80C',
  '#FF6AB8',
  '#02BBDC',
  '#3582DB',
  '#67CB29',
  '#00B778',
  '#02701F',
  '#FF7636',
  '#E99200',
];
